import React from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import Loading from 'core/Loading';
import { PageHeader } from 'modules/experience/components/layout/PageHeader';
import { useExperienceModuleContext } from 'modules/experience/context';

import useBestOfWoltFeatureFlag from '../hooks/useBestOfWoltFeatureFlag';
import { IndexPage } from '../pages/IndexPage';

export const ExperienceBestOfWolt = () => {
  const { selectedVenueExperienceEntity } = useExperienceModuleContext();
  const venue = selectedVenueExperienceEntity.experienceEntityObject as Venue;
  // todo @navjotahuja92 Use venue based on entityType
  const { isBestOfWoltEnabled, isLoading } = useBestOfWoltFeatureFlag({
    venueId: venue.id,
    venueCountry: venue.country,
    venueCity: venue.city,
  });

  if (isLoading) {
    return <Loading />;
  }

  return isBestOfWoltEnabled ? (
    <>
      <PageHeader />
      <IndexPage venueId={venue.id} venueTimezone={venue.timezone} />
    </>
  ) : (
    // show not suported page
    <div> Not Supported </div>
  );
};
